export enum Language {
    french = 'fr',
    english = 'en',
}

export interface UserSettings {
    language: Language | string;
}
